// GENERATED by scripts/build-icons.mjs from icons/zoom-in.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const ZoomIn = createIcon('zoom-in', [
  ['circle', { cx: "11", cy: "11", r: "8" }],
  ['line', { x1: "21", x2: "16.65", y1: "21", y2: "16.65" }],
  ['line', { x1: "11", x2: "11", y1: "8", y2: "14" }],
  ['line', { x1: "8", x2: "14", y1: "11", y2: "11" }],
])
